import { render, staticRenderFns } from "./AccountingPointPlanCard.vue?vue&type=template&id=0206dbf0&"
import script from "./AccountingPointPlanCard.vue?vue&type=script&lang=ts&"
export * from "./AccountingPointPlanCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
